module.exports = __webpack_public_path__ + "img/lunsresort.152d56b0.jpg";